var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColleagues = function SvgColleagues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "\\uD68C\\uC0AC \\uB3D9\\uB8CC \\uC544\\uC774\\uCF58(\\uB450 \\uC0AC\\uB78C)"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 42,
    r: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 120c0-30 20-50 50-50s50 20 50 50v6H20v-6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 48,
    r: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 126c0-26 18-44 40-44s40 18 40 44H95z"
  })));
};
export default SvgColleagues;